import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

export default function ProtectedRoute({ children, roles = [] }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ padding: '2rem' }}>
        Verificando acesso...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (
    roles.length > 0 &&
    !roles.some(role => user.roles?.includes(role))
  ) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
